export default {
  standings: {
    title: "Tabellen",
    empty: {
      unavailable: "Tabellen sind derzeit nicht verfügbar.",
    },
    labels: {
      ranking: "#",
      team: "Team",
    },
    columns: {
      GP: "Sp",
      W: "S",
      L: "N",
      T: "U",
      OTL: "OTN",
      PTS: "Pkt",
      PCT: "PCT",
      D: "U",
    },
    picker: {
      conference: "Conference",
      division: "Division",
      overall: "Gesamt",
    },
    sections: {
      conference: "Conference",
      division: "Division",
      overall: "Gesamt",
    },
  },
};
